import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {
  NgForm,
  FormBuilder,
  FormGroup,
  ControlContainer,
  FormControl,
  Validators
} from "@angular/forms";
import {CommonSelectListService} from "../../service/common-select-list.service";
import {AbstractBaseDetailsComponent} from "../../../core/component/abstract-base-details-component";
import {DynamicControlService} from "../service/dynamic-control.service";
import {ToastrService} from "ngx-toastr";
import {ProcessModel} from "../../../modules/process/model/process.model";
import {DynamicDataModel} from "../model/dynamic-data-model";
import {CustomModuleField} from "../../../modules/custom-module-field/model/custom-module-field";
import {ResponseCode} from "../../../core/constant/response-code";

@Component({
  selector: 'app-dynamic-field',
  templateUrl: './dynamic-field.component.html',
  styleUrls: ['./dynamic-field.component.css'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class DynamicFieldComponent extends AbstractBaseDetailsComponent implements OnInit,OnChanges {
  @Input() moduleId: number;
  @Input() processId: number;

  @Input() parentFromGroup: FormGroup;

  @Input() submitted;

  @Input() dataModel: Array<DynamicDataModel>;

  @Input()
  isUpdateComponent : boolean;

  @Output()
  onValueChange : EventEmitter<Array<DynamicDataModel>> = new EventEmitter<Array<DynamicDataModel>>();

  private isOnChangeChanges : boolean = true;


  //data: Array<CustomModuleField>;
  constructor(
      private dynamicService: DynamicControlService,
      private formBuilder: FormBuilder,
      public toastrService: ToastrService,
      private commonService: CommonSelectListService,
  ) { super(toastrService); }

  ngOnInit(){
    if(!this.isUpdateComponent){
      this.getDynamicConfig();
      return;
    }
    this.validateDynamicConfig();
    this.getLists();


  }

  getDynamicConfig() {

    let reqObj = {
      moduleId: this.moduleId,
      processId: (this.processId ? this.processId : undefined)
    };
    this.commonService.getDynamicFieldConfig(reqObj).subscribe((response) => {
      this.validateResponse(response, () => {

        if(response && response.responseCode == ResponseCode.OK && response.dataList && response.dataList.length > 0){
          this.dataModel = new Array<DynamicDataModel>();

          response.dataList.forEach(
              (field) =>{
                let dataValueModel : DynamicDataModel = new DynamicDataModel();
                dataValueModel.moduleCustomFieldId = field;
                this.dataModel.push(dataValueModel);
              }
          );
          this.validateDynamicConfig();
          this.getLists();
        }
      });
    });
  }

  validateDynamicConfig() {
    if (this.dataModel) {
      this.dataModel.forEach((data) => {
        this.parentFromGroup.addControl('dynamicField_'+data.moduleCustomFieldId.customField.id, data.moduleCustomFieldId.customField.required ? new FormControl(data.moduleCustomFieldId.customField.value || '', Validators.required)
            : new FormControl(data.moduleCustomFieldId.customField.value || ''));
      });
    }
  }

  getLists() {

    if(this.dataModel){
      this.dataModel.forEach((list) => {
        if (list.moduleCustomFieldId.customField && list.moduleCustomFieldId.customField.valueType &&  list.moduleCustomFieldId.customField.valueType.toUpperCase() === 'LIST') {
          list.moduleCustomFieldId.customField.fieldList = (list.moduleCustomFieldId.customField.valueList ? list.moduleCustomFieldId.customField.valueList.split(',') : []);
        }
      });
    }

  }

  keypress(event) {
    const pattern = /[0-9\.]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && event.keyCode != 9 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onBlur() {
    this.isOnChangeChanges = true;
    this.onValueChange.emit(this.dataModel);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.isOnChangeChanges){
      this.isOnChangeChanges = false;
      return;
    }
    this.removeValidation();
    this.dataModel = undefined;
    this.getDynamicConfig();
  }

  removeValidation(){
    if (this.dataModel) {
      this.dataModel.forEach((data) => {
        this.parentFromGroup.removeControl('dynamicField_'+data.moduleCustomFieldId.customField.id);
      });
    }
  }
}
